import { IntervalosHoras } from "components/Types/GeneralTypes";
import { HoraPermisoVacaciones } from "components/UsuarioGeneral/Vacaciones/Solicitud Vacaciones/TypesSolicitudVacaciones";



type InformacionTraslapaHoras = {
    traslapa:boolean,
    horadesdetraslapan:string,
    horahastatraslapan:string
}
export function RestarHoras(horaInicio: string, horaFin: string): string {
    // Parsear la hora de inicio y fin en formato HH:MM
    const [inicioHoras, inicioMinutos] = horaInicio.split(':').map(Number);
    const [finHoras, finMinutos] = horaFin.split(':').map(Number);

    // Convertir ambas horas a minutos totales desde el inicio del día
    const totalMinutosInicio = inicioHoras * 60 + inicioMinutos;
    const totalMinutosFin = finHoras * 60 + finMinutos;

    // Obtener la diferencia de minutos entre las dos horas
    let diferenciaMinutos = totalMinutosFin - totalMinutosInicio;

    // Si la diferencia es negativa, significa que la hora de fin es al día siguiente
    if (diferenciaMinutos < 0) {
        diferenciaMinutos += 24 * 60;  // Sumar 24 horas en minutos
    }

    // Convertir la diferencia en horas y minutos
    const horas = Math.floor(diferenciaMinutos / 60);
    const minutos = diferenciaMinutos % 60;

    // Retornar el resultado en formato HH:MM
    return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
}

export function EsMayorHora(hora1: string, hora2: string): boolean {
    // Parsear las horas en formato HH:MM
    const [hora1Horas, hora1Minutos] = hora1.split(':').map(Number);
    const [hora2Horas, hora2Minutos] = hora2.split(':').map(Number);

    // Convertir ambas horas a minutos totales desde el inicio del día
    const totalMinutosHora1 = hora1Horas * 60 + hora1Minutos;
    const totalMinutosHora2 = hora2Horas * 60 + hora2Minutos;

    // Retornar si la primera hora es mayor que la segunda
    return totalMinutosHora1 > totalMinutosHora2;
}

export function EsMayorIgualHora(hora1: string, hora2: string): boolean {
    // Parsear las horas en formato HH:MM
    const [hora1Horas, hora1Minutos] = hora1.split(':').map(Number);
    const [hora2Horas, hora2Minutos] = hora2.split(':').map(Number);

    // Convertir ambas horas a minutos totales desde el inicio del día
    const totalMinutosHora1 = hora1Horas * 60 + hora1Minutos;
    const totalMinutosHora2 = hora2Horas * 60 + hora2Minutos;

    // Retornar si la primera hora es mayor que la segunda
    return totalMinutosHora1 >= totalMinutosHora2;
}

export function SumarHoras(hora1: string, hora2: string): string {
    // Parsear las horas en formato HH:MM

    hora1 = hora1 === "" ? "00:00" : hora1;
    hora2 = hora2 === "" ? "00:00" : hora2

    const [hora1Horas, hora1Minutos] = hora1.split(':').map(Number);
    const [hora2Horas, hora2Minutos] = hora2.split(':').map(Number);

    // Convertir ambas horas a minutos totales desde el inicio del día
    const totalMinutosHora1 = hora1Horas * 60 + hora1Minutos;
    const totalMinutosHora2 = hora2Horas * 60 + hora2Minutos;

    // Sumar los minutos totales
    const totalMinutosSumados = totalMinutosHora1 + totalMinutosHora2;

    // Convertir el total de minutos nuevamente a horas y minutos
    const horas = Math.floor(totalMinutosSumados / 60);
    const minutos = totalMinutosSumados % 60;

    // Asegurarse de que el formato de los minutos sea siempre de dos dígitos
    const horasFormateadas = horas.toString().padStart(2, '0');
    const minutosFormateados = minutos.toString().padStart(2, '0');

    // Retornar el resultado en formato HH:MM
    return `${horasFormateadas}:${minutosFormateados}`;
}

export function SumarHorasListado(horas: string[]): string {
    let totalMinutos = 0;

    horas.forEach(hora => {
        // Si la hora es una cadena vacía, la reemplaza por "00:00"
        if (hora === "") {
            hora = "00:00";
        }

        const [horas, minutos] = hora.split(':').map(Number);
        totalMinutos += horas * 60 + minutos; // Convierte todo a minutos y suma
    });

    // Convierte el total de minutos a horas y minutos
    const horasTotales = Math.floor(totalMinutos / 60);
    const minutosTotales = totalMinutos % 60;

    // Retorna el resultado en formato "HH:MM"
    return `${horasTotales.toString().padStart(2, '0')}:${minutosTotales.toString().padStart(2, '0')}`;
}


export function TraslapaHoras(horas: HoraPermisoVacaciones[], horadesde: string, horahasta: string) {
    const toMinutes = (hora: string): number => {
        const [h, m] = hora.split(":").map(Number);
        return h * 60 + m;
    };

    var respuesta:InformacionTraslapaHoras = {
        horadesdetraslapan:"",
        horahastatraslapan:"",
        traslapa:false
    }
    const nuevaInicio = toMinutes(horadesde);
    const nuevaFin = toMinutes(horahasta);

    for (const horario of horas) {
        const inicio = toMinutes(horario.horadesde);
        const fin = toMinutes(horario.horahasta);

        // Se traslapan si uno empieza antes de que el otro termine y viceversa
        if (inicio < nuevaFin && nuevaInicio < fin) {
            respuesta = {
                horadesdetraslapan: horario.horadesde,
                horahastatraslapan: horario.horahasta,
                traslapa:true
            }

            return respuesta;
        }
    }

    return respuesta;

}

